
import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { StatutCode } from 'src/models/statut-code';

@Component({
    selector: 'app-novo-page-erreur',
    templateUrl: './novo-page-erreur.component.html',
    styleUrls: ['./novo-page-erreur.component.scss'],
    imports: [
    MatIcon,
    RouterModule,
    TranslateModule
]
})
export class NovoPageErreurComponent implements OnInit {
  icon: string = 'warning_amber';
  codeMessage: string = 'PAGE_ERREUR.ERREUR_404';

  erreur!: any;
  code!: number;

  constructor(private router : Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe( (paramMap: any) => {
      if (paramMap['error']) {
    try {
      this.erreur = JSON.parse(paramMap['error']);
      this.traiterErreur();
    } catch (e) {
      console.error("Erreur lors du parse:", e);
    }
  }
    })
  }

  redirectToAcceuil(){
    this.router.navigate(['/accueil']);
  }

  traiterErreur(){
    this.code = this.erreur.status;
      if (this.code == StatutCode.NotFound) {
        this.codeMessage = "PAGE_ERREUR.ERREUR_404";
        this.icon = 'search_off';
      } else if ( this.erreur.status == StatutCode.ServiceUnavailable) {
        window.location.href = environment.Redirect_Page_Maintenance;
      } else if ( this.erreur.status == StatutCode.Unauthorized) {
        this.codeMessage = "PAGE_ERREUR.ERREUR_401";
        this.icon = 'lock';
      } else if ( this.erreur.status == StatutCode.Forbidden) {
        this.codeMessage = "PAGE_ERREUR.ERREUR_403";
        this.icon = 'block';
      } else if ( this.erreur.status == StatutCode.BadRequest) {
        this.codeMessage = "PAGE_ERREUR.ERREUR_400";
        this.icon = 'highlight_off';
      } else if ( this.erreur.status == StatutCode.InternalServer) {
        this.codeMessage = "PAGE_ERREUR.ERREUR_500";
        this.icon = 'warning_amber';
      } else {
        this.codeMessage = "PAGE_ERREUR.ERREUR_500";
        this.icon = 'warning_amber';
    }
  }

}
